// extracted by mini-css-extract-plugin
module.exports = {"icon":"Datepicker_icon__1zJMx","containerDatepicker":"Datepicker_containerDatepicker__1d-S4","date":"Datepicker_date__2rC0_"};